import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import data from './data.json';
import Button from '../button/Button';

import featured from '../../../content/media-library/icons/featured.svg';
import backArrow from '../../../content/media-library/icons/back-arrow.svg';
import show from '../../../content/media-library/icons/show.svg';
import hide from '../../../content/media-library/icons/hide.svg';

const Drawer = ({ dataset }) => {
  const { backLabel, backUrl, navItemType, navItems } = data[dataset];
  const [isOpen, setIsOpen] = useState(false);

  const componentClasses = classnames([
    'drawer--grid-wrapper',
    {
      'drawer--grid-wrapper__open': isOpen
    }
  ]);

  const toggleDrawer = () => {
    trackAction(`${navItemType} menu click`, `Show ${navItemType}`);
    setIsOpen(!isOpen);
  };

  const trackAction = (category, action) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'drawerInteraction',
        drawerCategory: category,
        drawerAction: action
      });
    }
  };

  return (
    <section className="drawer">
      <div className="drawer--top-bar">
        <a href={backUrl} onClick={() => trackAction(`${navItemType} menu click`, `Back to ${backLabel}`)}>
          <img src={backArrow} alt="Back arrow" />
          <span>
            Back <span className="drawer--top-bar__show-on-desktop">to {backLabel}</span>
          </span>
        </a>
        <Button variant="secondary" onClick={() => toggleDrawer()}>
          <img src={isOpen ? hide : show} alt="" /> {isOpen ? `Hide ${navItemType}` : `Show ${navItemType}`}
        </Button>
      </div>

      <div className={componentClasses}>
        <div className="drawer--grid">
          {navItems.map((item) => (
            <a
              key={item.text}
              href={item.url}
              onClick={() => trackAction(`${navItemType} menu click`, `${item.text} item`)}
            >
              <span className={item.icon}></span> <span>{item.text}</span>{' '}
              {item.featured && <img src={featured} alt="Featured item" />}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

Drawer.propTypes = {
  dataset: PropTypes.string.isRequired
};

export default Drawer;
